import React from 'react'

import './paragraph.sass'

interface Props {
    text: string
}

const Paragraph = ({ text }: Props) => {
    return <p className="paragraph">{text}</p>
}

export default Paragraph
